import React from 'react';
import { Descriptions, Modal, Spin } from 'antd';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import UIHelper from '../../../../../../helpers/UIHelper';
import useCompanies from '../../useCompanies';

const ViewModal = () => {
  const { t } = useTranslation();
  const { singleItem } = useCompanies({ isMainPage: false });
  const { pathname, search } = useLocation();
  const history = useNavigate();
  const handleCancel = () => {
    history(UIHelper.getListRoute(pathname) + search);
  };

  return (
    <Modal
      title={t('Dettagli società')}
      visible={true}
      footer={false}
      onCancel={handleCancel}
    >
      <Descriptions column={1} bordered>
        {singleItem ? (
          <>
            <Descriptions.Item label={t('Titolo')}>
              {singleItem.title}
            </Descriptions.Item>
            <Descriptions.Item label={t('Codice IVA')}>
              {singleItem.tax_code}
            </Descriptions.Item>
            <Descriptions.Item label={t('Indirizzo')}>
              {singleItem.address}
            </Descriptions.Item>

            <Descriptions.Item label={t('Codice Ateco')}>
              {singleItem.ateco_code}
            </Descriptions.Item>

            <Descriptions.Item label={t('Codice SDI')}>
              {singleItem.invoice_code}
            </Descriptions.Item>
            <Descriptions.Item label={t('stripe_id')}>
              {singleItem.stripe_id}
            </Descriptions.Item>

            <Descriptions.Item label={t('Insegna')}>
              {singleItem?.shops?.map((i) => i.title).join(',')}
            </Descriptions.Item>
          </>
        ) : (
          <Spin size={'large'} />
        )}
      </Descriptions>
    </Modal>
  );
};

export default ViewModal;
